<template>
  <span class="mr-3 ml-3">
    <v-dialog v-model="dialogDocumentTypeVisibility" persistent max-width="520">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-if="!documentType.visible"
          v-bind="attrs"
          v-on="on"
          color="orange darken-2"
          >{{ icon.eyeOff }}</v-icon
        >

        <v-icon v-else v-bind="attrs" v-on="on" color="green darken-2">{{
          icon.eye
        }}</v-icon>
      </template>
      <v-card>
        <v-card-title class="headline">{{
          (documentType.visible
            ? documentTypeVisibilityFalseLabels.questionText
            : documentTypeVisibilityTrueLabels.questionText
          ).replace('@', documentType.nombre)
        }}</v-card-title>
        <v-card-text>{{
          documentType.visible
            ? documentTypeVisibilityFalseLabels.descriptionText
            : documentTypeVisibilityTrueLabels.descriptionText
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" text @click="onVisibility" :loading="loading">{{
            documentType.visible
              ? documentTypeVisibilityFalseLabels.positiveButtonText
              : documentTypeVisibilityTrueLabels.positiveButtonText
          }}</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="dialogDocumentTypeVisibility = false"
            :disabled="loading"
            >{{
              documentType.visible
                ? documentTypeVisibilityFalseLabels.negativeButtonText
                : documentTypeVisibilityTrueLabels.negativeButtonText
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { pushNotification, messageErrorResponse } from '@/store/helpers'

import {
  documentTypeStoreData,
  documentTypeStoreActions
} from '../store/documentTypeStoreHelpers'

export default {
  name: 'DocumentTypeVisibility',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icon: {
        eye: mdiEyeOutline,
        eyeOff: mdiEyeOffOutline
      },
      loading: false,
      dialogDocumentTypeVisibility: false
    }
  },
  computed: {
    ...documentTypeStoreData,
    documentType() {
      return Object.assign({}, this.value)
    }
  },
  methods: {
    ...documentTypeStoreActions,
    onVisibility() {
      this.loading = true

      let data = {
        idTipoDocumento: this.documentType.idTipoDocumento,
        visible: !this.documentType.visible
      }

      this.updateDocumentType(data)
        .then(result => {
          this.$emit('onUpdate', result)
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          this.loading = false
          this.dialogDocumentTypeVisibility = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgDocumentTypeServicePutError,
        'error',
        'left',
        false,
        false
      )
    }
  }
}
</script>
